import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

const API_URL = process.env.REACT_APP_BACKEND_URL;

export const AdminLogin = () => {
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);

    try {
      const formData = new FormData();
      formData.append('password', password);

      const response = await fetch(`${API_URL}/api/admin/login`, {
        method: 'POST',
        body: formData
      });

      if (response.ok) {
        // Store password in sessionStorage for subsequent requests
        sessionStorage.setItem('admin_password', password);
        navigate('/admin/dashboard');
      } else {
        setError('Invalid password');
      }
    } catch (err) {
      setError('Login failed. Please try again.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-gradient-to-br from-primary/10 via-white to-accent/10 flex items-center justify-center px-4">
      <div className="max-w-md w-full">
        {/* Logo/Header */}
        <div className="text-center mb-8">
          <img 
            src="https://customer-assets.emergentagent.com/job_pet-relocation-hub/artifacts/87vqpckq_Pawsome%20Logo.jpg" 
            alt="Pawsome Ventures" 
            className="w-32 h-32 mx-auto mb-4 rounded-full"
          />
          <h1 className="text-3xl font-bold text-primary mb-2">Pawsome Ventures</h1>
          <p className="text-foreground/60">Admin Portal</p>
        </div>

        {/* Login Card */}
        <div className="bg-white rounded-2xl shadow-xl p-8 border border-border">
          <h2 className="text-2xl font-bold text-foreground mb-6">Admin Login</h2>
          
          <form onSubmit={handleLogin}>
            <div className="mb-6">
              <label className="block text-sm font-medium text-foreground/70 mb-2">
                Password
              </label>
              <input
                data-testid="admin-login-password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                className="w-full px-4 py-3 rounded-lg border border-border focus:outline-none focus:ring-2 focus:ring-primary focus:border-transparent"
                placeholder="Enter admin password"
                required
              />
            </div>

            {error && (
              <div data-testid="admin-login-error" className="mb-4 p-3 bg-red-50 border border-red-200 text-red-600 rounded-lg text-sm">
                {error}
              </div>
            )}

            <button
              data-testid="admin-login-submit"
              type="submit"
              disabled={loading}
              className="w-full bg-primary text-white py-3 rounded-lg font-semibold hover:bg-primary/90 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? 'Logging in...' : 'Login'}
            </button>
          </form>

          <div className="mt-6 text-center">
            <a href="/" data-testid="admin-login-back-to-website" className="text-sm text-primary hover:text-primary/80">
              ← Back to Website
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};